<div class="card">
	<canvas baseChart [data]="chart.data" [options]="chart.options" [type]="'line'" width="100%" height="30rem"></canvas>
</div>
